/**
 * Family membership chip (WSRADM-0025). Label is already-resolved
 * `Dimension: Family` text. Colour is null-safe via familyColorOrNeutral.
 */
import { Chip } from '@mui/material';
import { familyColorOrNeutral } from './familyPalette';

export interface FamilyChipProps {
  dimensionName: string;
  familyName: string;
  color: string | null; // the family's raw colour; resolved via familyColorOrNeutral
  size?: 'small' | 'medium'; // forwarded to Chip only when given
}

export function FamilyChip({ dimensionName, familyName, color, size }: FamilyChipProps) {
  const label = `${dimensionName}: ${familyName}`;
  const resolved = familyColorOrNeutral(color);
  return (
    <Chip
      label={label}
      title={label}
      {...(size !== undefined ? { size } : {})}
      {...(resolved !== null
        ? { sx: { bgcolor: resolved.bg, color: resolved.fg } }
        : { variant: 'outlined' as const })}
    />
  );
}
